import styled, {createGlobalStyle, css} from 'styled-components';
import PropTypes from 'prop-types';
import {Form as FormFormik} from 'formik';
import {Link as LinkRouter} from 'react-router-dom';
import iconArrowRight from '../../assets/icon/ico-arrow-right.png'
import iconCheckmark from '../../assets/icon/icon-checkmark.svg'
import iconSearch from '../../assets/icon/icon-search.svg'
import ImageHealthUdder from '../../assets/images/image-health-udder.svg';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  *, button, input {
    border: 0;
    outline: 0;
    font-family: 'Open Sans', sans-serif;
    letter-spacing: -1px;
  }
  
  button, input {
    color: black;
  }
  
  body{
    font-size: 16px;
    color: #ffffff;
  }
  .complete {
    text-decoration: line-through;
  }
`;

export const ButtonDefault = styled.button`
  line-height: 48px;
  border-radius: 30px;
  padding: 0 15px;
  margin: 15px 0;
  text-transform: uppercase;
  cursor: pointer;
  font-size: 16px;
  transition: all 300ms ease;
  font-weight: bold;
  font-style: normal;
  &[disabled] {
    opacity: 0.4;
    cursor: no-drop;
  }
`;

export const SubmitErrorButton = styled.button`
  background-size: 22px;
  height: 24px;
  width: 24px;
  cursor: pointer;
  margin-right: 8px;
`;

export const Button = styled(ButtonDefault)`
  box-shadow: 0 12px 14px -8px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  border: 1px solid #320533;
  color: #fff;
  width: ${({width = '100%'}) => `${width}`};
  background: #320533;
  height: 45px;
  font-size: 18px;
  line-height: 0px;
  text-transform: none;
  font-family: Manrope;
`;

export const DivActionBack = styled.div`  
    position: absolute;
    z-index: 3;
    margin: 15px 0px 0 30px;
`;

export const ButtonActionBack = styled.button`  
  font-family: Manrope;
  box-shadow: none;
  border: none;
  display:flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  width: ${({width = '100%'}) => `${width}`};
  background: transparent;
  height: 45px;
  font-size: 18px;
  cursor: pointer;
`;

export const ImgIconBack = styled.img`  
  margin-right: 10px;
`;

export const ButtonSelectFarm = styled(ButtonDefault)`
  font-family: Manrope;
  box-shadow: 0 12px 14px -8px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  border: 1px solid #d7d3d3;
  color: #777777;
  width: ${({width = '100%'}) => `${width}`};
  background: #ffffff;
  display: flex;
  justify-content: start;
  align-items: center;
  text-transform:none;
  position: relative;
  margin-bottom: 0;
  margin-top: 0;
  min-height: 52px;
  height: 100%;
  line-height: unset;
  padding: 0 1.6rem 0 1.6rem;
    &:focus {
       background: rgb(28, 41, 55);
       color: #ffffff;
    }
    &:before{
        content: '';
        background: url(${iconArrowRight}) no-repeat 100%;
        object-fit: cover;
        width: 20px;
        display: block;
        height: 20px;
        right: 15px;
        position: absolute;
    }
`;

export const ImgUdderHealth = styled.div`
   background: url(${ImageHealthUdder}) no-repeat;
   height: 40px;
   width: 120px;
`;

export const ButtonSelectCategory = styled(ButtonDefault)`
  box-shadow: 0 12px 14px -8px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  border: 1px solid #d7d3d3;
  color: #777777;
  width: ${({width = '100%'}) => `${width}`};
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform:none;
  position: relative;
  margin-bottom: 0;
  margin-top: 0;
  height: 52px;
    &:focus {
       background: linear-gradient(260deg, #E6037F 20.98%, #99175C 90.65%);
       color: #ffffff;
    }
    &:before{
        content: '';
        background: url(${iconCheckmark}) no-repeat 100%;
        object-fit: cover;
        width: 20px;
        display: block;
        height: 20px;
        right: 15px;
        position: absolute;
    }  
`;

export const ButtonAppStore = styled(ButtonDefault)`
  box-shadow: 0 12px 14px -8px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  border: 1px solid #490026;
  color: #FFF;
  background: #490026;
  font-family: Manrope;
  width: ${({ width = '100%' }) => `${width}`};
`;

export const ButtonAppWeb = styled(ButtonDefault)`
  box-shadow: 0 12px 14px -8px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  border: 1px solid #490026;
  color: #FFF;
  font-family: Manrope;
  background: #490026;
  width: ${({ width = '100%' }) => `${width}`};
`;

export const InfoTooltip = styled.div`
  position: absolute;
  color: black;
  left: 87%;
  top: 7px;
  color: #99175c;
  border: 3px solid #99175c;
  background-color: white;
  border-radius: 100px;
  width: 33px;
  padding: 5px;
  font-weight: 900;
  font-size: 15px;
  cursor: pointer;

  .info-message {
    display: none;
  }

  &:hover .info-message {
    display: block;
    position: absolute;
    top: -3px;
    left: 34px;
    width: 215px;
    z-index: 999;
    background-color: white;
    border: 3px solid #99175c;
    border-radius: 16px;
    padding: 10px;
    font-weight: 600;
  }
  @media (max-width: 801px) {
    &:hover .info-message {
      top: -169px;
      left: -156px;
    }
  }
`;

export const ButtonOutline = styled(ButtonDefault)`
  background: #ffffff;
  box-shadow: 0 12px 14px -8px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  color: #000000;
  border: 1px solid #000000;
  box-sizing: border-box;
  width: ${({width = '100%'}) => `${width}`};
  &:hover {
    background-color: #db2174;
    color: #ffffff;
    border: 1px solid #ffffff;
  }
`;

export const ButtonSecondary = styled(ButtonDefault)`
  background: none;
  border: 1px solid #fff;
  color: #fff;
  &:hover {
    background-color: rgba(0, 176, 230, 0.25);
  }
`;

export const SignInButtons = styled.div`
  button {
    margin: 5px;
  }
`;

export const SignInButtonsAppStore = styled.div`
  button {
    margin: auto 0 auto auto;
  }
`;

export const SignInButtonsAppWeb = styled.div`
  button {
    margin: auto 0 auto auto;
  }
`;

export const ButtonNoFormat = styled.div`
  cursor: pointer;
`;

export const Title = styled.div`
  margin-bottom: 18px;
`;



export const HeaderTitle = styled.div`  
  position: absolute;
  z-index: 2;
  color: #fff;
  width: 100%;
  padding: 70px 0 0 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const H1 = styled.h1`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  margin: 0;
`;

export const LegendTitle = styled.h1`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  margin: 0;
  max-width: 95%;
`;

export const H2 = styled.h1`
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 40px;
  text-align: center;
  margin: 0;
  max-width: 95%;
`;

export const H2FarmStore = styled.h1`
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 40px;
  text-align: center;
  margin: 0;
  max-width: 20%;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const calcSize = (size) => (100 / (12 / size)).toFixed(5);

export const Col = styled.div`
  position: relative;
  width: 100%;
  padding: 0 15px;
  ${({size}) =>
    size &&
    css`
      flex: 0 0 ${calcSize(size)}%;
      max-width: ${calcSize(size)}%;
    `}
  ${({sm}) =>
    sm &&
    css`
      @media (min-width: 576px) {
        flex: 0 0 ${calcSize(sm)}%;
        max-width: ${calcSize(sm)}%;
      }
    `}
    ${({md}) =>
    md &&
    css`
      @media (min-width: 768px) {
        flex: 0 0 ${calcSize(md)}%;
        max-width: ${calcSize(md)}%;
      }
    `}
    ${({lg}) =>
    lg &&
    css`
      @media (min-width: 992px) {
        flex: 0 0 ${calcSize(lg)}%;
        max-width: ${calcSize(lg)}%;
      }
    `}
    ${({xl}) =>
    xl &&
    css`
      @media (min-width: 1200px) {
        flex: 0 0 ${calcSize(xl)}%;
        max-width: ${calcSize(xl)}%;
      }
    `}
`;

export const Form = styled(FormFormik)`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const FormControl = styled.div`
  position: relative;
  margin-bottom: 15px;
  width: 100%;
  text-align: center;
`;

export const ContainerFarmsSelects = styled.div`
    overflow: auto;
    height: 20vh;
`;

export const Label = styled.label`
  font-weight: 600;
  font-style: normal;
  font-size: 16px;
  line-height: 22px;
  color: ${({disabled}) => (disabled ? css`white` : css`#fffffff`)};
  float: left;

  > input {
    margin-right: 5px;
  }
  > a {
    color: #00b0e6;
  }
`;

export const LabelAppStore = styled.label`
  font-weight: 600;
  font-style: normal;
  font-size: 16px;
  line-height: 22px;
  color: #fff;
  float: left;
`;


export const LabelAppWeb = styled.label`
  font-weight: 600;
  font-style: normal;
  font-size: 16px;
  line-height: 22px;
  color: #354158;
  float: left;
`;

export const Hint = styled.div`
  font-size: 12px;
  color: black;
  text-align: left;
  margin-top: 15px;
  > div {
    margin-top: 5px;
    font-weight: bold;
  }
  ul {
    padding-left: 20px;
    li {
      font-size: 11px;
    }
  }
`;

export const InputError = styled.div`
  font-size: 12px;
  color: black;
  text-align: left;
  margin-top: 3px;
`;

export const InputErrorAppWeb = styled.div`
  font-size: 12px;
  color: #ff0000;
  text-align: left;
  margin-top: 3px;
`;

export const SubmitError = styled.div`
  background: #ffdee0;
  border-radius: 4px;
  width: 100%;
  padding: 11px 15px;
  display: flex;
  align-items: center;

  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 23px;
  color: #f5222d;
`;

// export const SubmitErrorButton = styled.button`
//   background: url('${CloseIcon}') no-repeat center center;
//   background-size: 22px;
//   height: 24px;
//   width: 24px;
//   cursor: pointer;
//   margin-right: 8px;
// `;

export const RadioGroup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  input {
    height: initial;
    width: initial;
    cursor: pointer;
  }
`;

export const RadioGroupTitle = styled.div``;
export const RadioRow = styled.div`
  display: inline;
  label {
    margin-right: 10px;
  }
  input {
    margin-top: 5px;
  }
`;

export const Input = styled.input`
  font-family: Manrope;
  height: 48px;
  background: ${({disabled}) => (disabled ? css`#e3dfdf` : css`#ffffff`)};
  color: ${({disabled}) => (disabled ? css`#5c5454` : css`black`)};
  padding: 0 10px;
  width: 100%;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  border: 1px solid #c4c4c4;
  box-sizing: border-box;
  border-radius: 8px;
  transition: border 300ms ease;
  outline: 0;
  &:focus {
    border-color: #3898ec;
    outline: 0;
  }
  ::placeholder {
    color: ${({disabled}) => (disabled ? css`#777777` : css`#000000`)};
  }
`;

export const InputStyledAppWeb = styled.input`
  font-family: Manrope;
  height: 48px;
  background: #fff;
  color: #707070;
  padding: 0 10px;
  width: 100%;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  border: 1px solid #707070;
  box-sizing: border-box;
  border-radius: 6px;
  transition: border 300ms ease;
  outline: 0;
  &:focus {
    border: 1px solid #707070;
    outline: 0;
  }
`;

export const InputSearchFarm = styled.input`
  font-family: Manrope;
  height: 48px;
  background: #ffffff url('${iconSearch}') no-repeat calc(100% - 20px) center;
  color: ${({disabled}) => (disabled ? css`#5c5454` : css`black`)};
  padding: 0 10px;
  width: 100%;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  border: 1px solid #c4c4c4;
  box-sizing: border-box;
  border-radius: 8px;
  transition: border 300ms ease;
  outline: 0;
  &:focus {
    border-color: #3898ec;
    outline: 0;
  }
  ::placeholder {
    color: ${({ disabled }) => (disabled ? css`#777777` : css`#490026`)};
  }
`;

export const Select = styled.select`
  height: 48px;
  padding: 0 10px;
  width: 100%;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  border: 1px solid #c4c4c4;
  box-sizing: border-box;
  border-radius: 8px;
  transition: border 300ms ease;
  &:focus {
    border-color: #3898ec;
  }
  ::placeholder {
    color: black;
  }
`;

export const LinkBaseApp = styled(LinkRouter)`
  display: inline-flex;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #354158;
  text-decoration: underline;
  margin: auto auto auto 0;
  text-decoration: none;
  font-family: Manrope;
`;

export const LinkBaseAppWeb = styled(LinkRouter)`
  display: inline-flex;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #354158;
  text-decoration: underline;
  margin: auto auto auto 0;
  text-decoration: none;
  font-family: Manrope;
`;

export const Link = styled(LinkRouter)`
  display: inline-flex;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #183242;
  //text-transform: uppercase;
  text-decoration: underline;
  text-decoration: none;
  font-family: Manrope;
`;

Col.propTypes = {
    size: PropTypes.number.isRequired,
    sm: PropTypes.number,
    md: PropTypes.number,
    lg: PropTypes.number,
    xl: PropTypes.number,
};
